@if (showPdf) {
  <ngx-extended-pdf-viewer
    [src]="src"
    [showDownloadButton]="allowDownloadFile && !forceFullScreen"
    [print]="allowDownloadFile && !forceFullScreen"
    [zoom]="'page-width'"
    [theme]="'dark'"
    [backgroundColor]="simplifiedMode ? 'white' : '#424242'"
    [showToolbar]="!simplifiedMode"
    [showFindButton]="!forceFullScreen"
    [showBookModeButton]="false"
    [showHorizontalScrollButton]="false"
    [showInfiniteScrollButton]="false"
    [showWrappedScrollButton]="false"
    [showOpenFileButton]="false"
    [showTextEditor]="false"
    [showStampEditor]="false"
    [filenameForDownload]="fileName"
    [logLevel]="0"
    (pdfLoaded)="pdfLoaded()"
    (pageRendered)="pageRendered($event)">
  </ngx-extended-pdf-viewer>
} @else {
  <div (click)="loadPdf()" class="pdf-viewer__load-placeholder">
    <lib-icon icon="file-pdf" size="60"></lib-icon>
    Click to view PDF document
  </div>
}

